// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"styles_buttonContainer__2Kf6H","imageBG":"styles_imageBG__2YxGh","btnText":"styles_btnText__1pMzb"};